<template>
  <el-dialog
    :visible="showInfoDialog"
    :modal-append-to-body="false"
    :style="{fontFamily: 'trebuc', color:'#465656'}"
    @close="closeDialog"
    @visible-change="closeDialog"
    v-on:update:visible="closeDialog">
        
    <span slot="title" class="ticket-title"><b>{{dialogTitle}}</b></span>
    <p  v-if="dialogData.deliveryman_name" class="ticket_assignedTo"> <b> {{ "Asignado a " + dialogData.deliveryman_name }} </b></p>

    <el-steps
      :active="dialogData.statusId"
      finish-status="success"
      align-center>
      <el-step title="Por asignar" />
      <el-step title="Asignado" />
      <el-step title="Recolectando" />
      <el-step title="En ruta de entrega" />
      <el-step title="Entregado" />
    </el-steps>

    <div class="ticket_container">
      <div class="ticket_info">
        <p class="mb-1"><b>Fecha: </b>{{ dialogData.created_at }}</p>
        <p class="mb-1"><b>Nombre:</b> {{ dialogData.customer.name }}</p>
        <p class="mb-1">
          <b>Dirección: </b> {{ dialogData.customer.address.raw }} <br>
          <a
            :href="dialogData.customer.address.maps_url"
            target="_blank"
          >Link en maps</a>
        </p>
        <p class="mb-1 monospace"><b>Referencia: </b> <span v-html="dialogData.customer.address.notes"></span></p>
        <p class="mb-1"><b>Teléfono: </b> {{ dialogData.customer.phone }}</p>
        <p class="mb-1 monospace"><b>Subtotal: </b> {{ dialogData.subtotal }} </p>
        <p class="mb-1 monospace"><b>IVA: </b> {{ dialogData.tax }} </p>
        <p class="mb-1 monospace"><b>Total: </b> {{ dialogData.total }} </p>
      </div>

      <div class="ticket_map">
        <l-map
          style="height: 250px; width: 100%"
          :zoom="map.zoom"
          :center="map.center"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate">
          <l-tile-layer :url="map.url" />
          <l-marker
            v-for="(marker, index) in map.markers"
            :key="index"
            :icon="getIcon(marker)"
            :lat-lng="marker.pos">
            <l-tooltip>{{ marker.text }}</l-tooltip>
          </l-marker>
        </l-map>
      </div>  
    </div>

    <div class="ticket_table">
      <el-table
        :data="this.dialogData.items"
        style="width: 100%"
        :header-cell-style="{textAlign: 'center'}"
        :cell-style="cellStyle"
        stripe
        emptyText="No hay productos para este ticket.">
        <el-table-column
          prop="barcode"
          label="Producto"
          :width="180"
          align="center"
        />
        <el-table-column
          prop="name"
          label="Descripción"
          :width="350"
          align="center"
        />
        <el-table-column
          prop="units"
          label="Cantidad"
          :width="100"
          align="center"
        />
        <el-table-column
          prop="unit_price_formatted"
          label="Precio unitario"
          :width="150"
          align="right"
        />
        <el-table-column
          prop="total"
          label="Total"
          :width="120"
          align="right"
        />
      </el-table>
      </div>
  </el-dialog>
</template>

<script>
import { getDeliverymenLocation } from "@/api/deliverymen.js"
import {LMap, LTileLayer, LMarker, LTooltip} from 'vue2-leaflet';
import { nearestStoreWithTicket } from "@/api/stores.js";
import { time, colors } from "@/utils/utils.js"
export default {
  components : {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip
  },
  props: {
    dialogData : {
      required: true
    },
    dialogTitle : {
      required: true
    },
    showInfoDialog : {
      required: true
    },
  },
  data() {
    return {
      map: {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        zoom: 11,
        center: [],
        markers: []
      }
    }
  }, 
  methods : {
    mapInfo(dialogData) {
      this.map.markers = [];
      if(dialogData.customer.location.coordinates.length > 0) {
        console.log("Coordenadas", dialogData.customer.location.coordinates);
        this.map.center = dialogData.customer.location.coordinates;
        this.map.markers.push( { 
          pos: dialogData.customer.location.coordinates,
          text: "Dirección de entrega",
          color: "#40b4e5",
        });
        console.log("modal map", this.map);
      }

      getDeliverymenLocation(dialogData.deliveryman_uuid) 
        .then(location => {
          this.updateDeliverymenMarkers(location ,dialogData);
        })
        .catch(error => {
          console.log(error);
        });

      nearestStoreWithTicket(dialogData.customer_location, dialogData.items)
        .then(response => {
          if (Array.isArray(response)) {
            response.forEach(store => {
              this.map.markers.push( { 
                pos: [store.gps_latitud, store.gps_longitud],
                text: store.nombre + " <br/> " + "Ext. " + store.extension,
                color: "#00837A",
                icon: {
                  scaledSize: new google.maps.Size(100, 100)
                }
              });
            });
          } else {
            this.map.markers.push( { 
              pos: [response.gps_latitud, response.gps_longitud],
              text: response.nombre + " <br/> " + "Ext. " + response.extension,
              color: "#00837A",
              icon: {
                scaledSize: new google.maps.Size(100, 100)
              }
            });
          }
        })
        .catch(error => {
          console.log(error);
        });

      dialogData.items.forEach((item) => {
        if (item.recolections.length > 0) {
          item.recolections.forEach((recolection) => {
            console.log("recolection", recolection);
            this.map.markers.push( { 
              pos: [ recolection.location.coordinates[0], recolection.location.coordinates[1] ],
              text: `Recogido(s) ${recolection.units} ${item.name}`,
              color: "#e54062",
            });
          });
        }
      });

      if(dialogData.current_status == "delivered" ){
        let temp = dialogData.delivery.location;
        this.map.markers.push({
          pos:  [temp.coordinates[0], temp.coordinates[1]],
          color: "#b4e540",
          text: "Lugar de entrega",
        });
      }
    },

    updateDeliverymenMarkers(delivery,dialogData) {
      this.map.markers = this.map.markers.filter(marker => {
        return marker.type != "deliveryman"
      });

      if(dialogData.deliveryman_uuid == delivery.deliveryman_uuid) {
        if (delivery.location != null) {
          this.time = new Date(delivery.created_at);
          this.convertedTime = this.time.toTimeString().split(" ")[0];
          this.map.markers.push({
            pos: [delivery.location.latitude, delivery.location.longitude],
            text: dialogData.deliveryman_name + " <br/> " + this.convertedTime,
            type: "deliveryman",
            options: { permanent: false, zIndexOffset: 1000 },
            color: colors.getColor(dialogData.deliveryman_name)
          });
        }
      };
    },

    getIcon(item) {
      item.strokeColor = item.color;
      item.circleColor = '#FFFFFF';
      if(item.type == 'deliveryman'){
        return L.divIcon({
          className: "my-pin-delivery",
          html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892337" height="65" width="60" color="#000">
            <title>motorbike</title>
            <path d="M17.42,10L13.41,6H9V8H12.59L14.59,10H6.5C4,10 2,12 2,14.5C2,17 4,19 6.5,19C8.72,19 10.56,17.38 10.92,15.27L13.04,14C13,14.17 13,14.33 13,14.5C13,17 15,19 17.5,19C20,19 22,17 22,14.5C22,12 20,10 17.5,10M8.84,15.26C8.5,16.27 7.58,17 6.47,17C5.09,17 3.97,15.88 3.97,14.5C3.97,13.12 5.09,12 6.47,12C7.59,12 8.5,12.74 8.84,13.75H6V15.25L8.84,15.26M17.47,17C16.09,17 14.97,15.88 14.97,14.5C14.97,13.12 16.09,12 17.47,12A2.5,2.5 0 0,1 19.97,14.5A2.5,2.5 0 0,1 17.47,17Z" style="fill:${item.color};stroke:${item.strokeColor};" />
            </svg>`
        });
      }
      if(item.text == "Dirección de entrega"){
        return L.divIcon({
        className: "my-custom-pin-delivered",
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 34.892337"  height="50" width="45">
          <title>home</title>
          <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" style="fill:${item.color};stroke:${item.strokeColor};"/>
          </svg>`
        });
      }
      return L.divIcon({
        className: "my-custom-pin",
        html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 34.892337" height="45" width="40">
        <g transform="translate(-814.59595,-274.38623)">
          <g transform="matrix(1.1855854,0,0,1.1855854,-151.17715,-57.3976)">
            <path d="m 817.11249,282.97118 c -1.25816,1.34277 -2.04623,3.29881 -2.01563,5.13867 0.0639,3.84476 1.79693,5.3002 4.56836,10.59179 0.99832,2.32851 2.04027,4.79237 3.03125,8.87305 0.13772,0.60193 0.27203,1.16104 0.33416,1.20948 0.0621,0.0485 0.19644,-0.51262 0.33416,-1.11455 0.99098,-4.08068 2.03293,-6.54258 3.03125,-8.87109 2.77143,-5.29159 4.50444,-6.74704 4.56836,-10.5918 0.0306,-1.83986 -0.75942,-3.79785 -2.01758,-5.14062 -1.43724,-1.53389 -3.60504,-2.66908 -5.91619,-2.71655 -2.31115,-0.0475 -4.4809,1.08773 -5.91814,2.62162 z" style="fill:${item.color};stroke:${item.strokeColor};"/>
            <circle r="3.0355" cy="288.25278" cx="823.03064" id="path3049" style="display:inline;fill:${item.circleColor};"/>
          </g>
        </g>
        </svg>`
      });
    },
    centerUpdate(center) {
      this.map.center = center;
    },
    zoomUpdate(zoom) {
      this.map.zoom = zoom;
    },
    cellStyle( column, columnIndex, row, rowIndex) {
      if(column.property == 'total' || column.property == 'unit_price_formatted') {
        return {
          fontFamily: 'IBM Plex Mono, monospace',
          fontSize: '14px',
          color:'#465656'
        };
      } else {
          return {
            fontFamily: 'trebuc',
            fontSize: '15px',
            color:'#465656'
          };
      }
    },
    closeDialog(){
      this.$emit("close");
    },
  },
}
</script>

<style scoped>

.ticket_container {
  display: flex;
  width: 100%;
  min-height: 300px;
}

.ticket-title {
  font-family: 'trebuc';
  font-size: 20px;
  color: #465656;
}

.ticket_info {
  width: 45%;
  float: left;
  text-align: left;
  padding: 20px 0px 0px 40px;
}

.ticket_assignedTo {
  text-align: left;
  padding: 0px 0px 0px 40px;
  font-size: 18px;
}

.ticket_map {
  float: right;
  width: 50%;
  height: 250px;
  padding-top: 20px;
  margin-left: 25px;
  margin-right: 20px;
}

</style>